import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Form/form';
import { css } from '@patternfly/react-styles';
export var Form = function Form(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$isHorizontal = _a.isHorizontal,
      isHorizontal = _a$isHorizontal === void 0 ? false : _a$isHorizontal,
      _a$isWidthLimited = _a.isWidthLimited,
      isWidthLimited = _a$isWidthLimited === void 0 ? false : _a$isWidthLimited,
      _a$maxWidth = _a.maxWidth,
      maxWidth = _a$maxWidth === void 0 ? '' : _a$maxWidth,
      props = __rest(_a, ["children", "className", "isHorizontal", "isWidthLimited", "maxWidth"]);

  return React.createElement("form", Object.assign({
    noValidate: true
  }, maxWidth && {
    style: Object.assign({
      '--pf-c-form--m-limit-width--MaxWidth': maxWidth
    }, props.style)
  }, props, {
    className: css(styles.form, isHorizontal && styles.modifiers.horizontal, (isWidthLimited || maxWidth) && styles.modifiers.limitWidth, className)
  }), children);
};
Form.displayName = 'Form';